import appStore from "store/appStore";
import { useEffect, useRef, useState } from "react";
import { ShimmerDepartmentRender } from "components/app/shrimmer/Shrimmer";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import { AppLog } from "services";

import { useAppSelector } from "store/store";
import AccountDetailLayout from "layout/account-detail-layout/AccountDetailLayout";
import { Card } from "components/ui/card";
import { Service } from "utils/services";
import { PostReaction } from "models/postReaction";
import { Skeleton } from "components/ui/skeleton";
import DailogDetailCampaings from "./dailogCampaings/DailogDetailCampaings";
import DialogPostReaction from "components/app/dialog/DialogPostReaction";
import SwitchYesNo from "components/app/function/SwitchYesNo";
import { useNavigate } from "react-router-dom";
import { noneProfile } from "assets";
import { CircleCheck, CircleOff, CircleStop, Grid2x2, Trash2, WalletCards } from "lucide-react";
import SkeletonMusicLibrariesTable from "./music-libraries/skeleton/SkeletonMusicLibrariesTable";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";

export default function Campaigns() {
  const { showDialogConfirm } = appStore();
  const [isDailogDetailCampaing, setIsDailogDetailCampaings] = useState<boolean>(false);
  const [types, setTypes] = useState<any>();
  const [campaings, setCampaings] = useState<any>();
  const { token } = useAppSelector((state) => state.auth);

  const [campaingsloading, setCampaingsloading] = useState<boolean>();
  const [campaingsloadingSearch, setCampaingsloadingSearch] = useState<boolean>();

  const [selectCampaingTypes, setSelectCampaingTypes] = useState<any>("");

  const fetchCampaings = async () => {
    setCampaingsloading(true);
    try {
      const url = `${RouteApi.getCampaign}token=${token}`;

      const response = await RequestApi(url);
      if (response.status === "success") {
        setTypes(response["types"]);
        setCampaings(response.user_campaigns);
        setCampaingsloading(false);
      }
    } catch (error) {
      setCampaingsloading(false);

      AppLog.show({
        message: `[fetchCampaings]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchCampaingsSearch = async () => {
    setCampaingsloadingSearch(true);
    try {
      const url = `${RouteApi.getCampaignSearch}token=${token}`;
      const data = {
        type: selectCampaingTypes,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setCampaings(response?.user_campaigns);
        setCampaingsloadingSearch(false);
      }
    } catch (error) {
      setCampaingsloadingSearch(false);

      AppLog.show({
        message: `[fetchCampaingsSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const submitActiveCampaign = async (campaignId: string, value: string) => {
    try {
      const url = `${RouteApi.submitActiveCampaign}token=${token}`;
      const data = {
        campaign_id: campaignId,
        inactived: value === "Yes" ? "No" : "Yes",
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        // Optional: show success message
      }
    } catch (error) {
      AppLog.show({
        message: `[submitActiveCampaign]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [campaingsDetail, setCampaingsDetail] = useState<any>();
  const [campaingsDetailLoading, setCampaingsDetailLoading] = useState<boolean>(false);

  const getCampaignDetail = async (campaignId: number) => {
    setCampaingsDetailLoading(true);
    try {
      const url = `${RouteApi.getCampaignDetail}token=${token}`;
      const data = {
        campaign_id: campaignId,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setCampaingsDetailLoading(false);

        setCampaingsDetail(response.user_campaign);
      }
    } catch (error) {
      setCampaingsDetailLoading(false);

      AppLog.show({
        message: `[getCampaignDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [page, setPage] = useState(1); // or use scroll_tag if API uses that
  const [laodingScroll, setLaodingScroll] = useState<boolean>(false);
  const [hasMoreData, setHasMoreData] = useState<any>();

  const fetchMoreData = async () => {
    setIsFetching(true);
    setLaodingScroll(true);

    try {
      const url = `${RouteApi.getCampaignSearch}token=${token}`;
      const data = {
        type: selectCampaingTypes,
        page: page + 1,
      };
      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setLaodingScroll(false);
        setHasMoreData(response?.user_campaigns?.next_page_url !== null);

        setCampaings({
          ...campaings,
          data: [...(campaings?.data || []), ...response?.user_campaigns?.data],
        });
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      setLaodingScroll(false);

      AppLog.show({
        message: `[fetchMoreData]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setIsFetching(false);
    }
  };
  useEffect(() => {
    fetchCampaingsSearch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCampaingTypes]);
  useEffect(() => {
    fetchCampaings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClickCategory = ({ types }: { types: string }) => {
    if (selectCampaingTypes === types) return;
    setSelectCampaingTypes(types);
  };

  // -------------------------
  const postContents = (post: any) => {
    if (post?.media_type?.toLowerCase() === "photo" || post?.media_type?.toLowerCase() === "album") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden  pointer-events-none rounded-lg  cursor-pointer">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl  cursor-pointer"
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />
          <img
            // onClick={() => onGoToPost(post.provider_post_id)}
            style={{ cursor: "pointer" }}
            src={post.post_attachments[0].attachment_media_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto rounded-lg cursor-pointer   ${ratio >= 0 && ratio < 0.74 ? "object-cover rounded-lg" : "object-contain rounded-lg"}`}
            loading="lazy"
          />
        </div>
      );
    } else if (post.media_type?.toLowerCase() === "video") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden  pointer-events-none rounded-lg  cursor-pointer">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl  cursor-pointer"
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />

          <img
            // onClick={() => onGoToPost(post.provider_post_id)}
            style={{ cursor: "pointer" }}
            src={post.post_attachments[0].attachment_thumbnail_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto rounded-lg  cursor-pointer ${ratio >= 0 && ratio < 0.74 ? "object-cover rounded-lg" : "object-contain rounded-lg"}`}
            loading="lazy"
          />
        </div>
      );
    } else {
      return <div className="flex justify-center items-center">Content Not Found! {post.media_type}</div>;
    }
  };
  const [dialogPostReaction, setDialogPostReaction] = useState({
    isOpen: false,
    post: null,
    postReaction: PostReaction.like,
  });
  const onOpenReactionDialog = (post: any, postReaction: PostReaction) => {
    try {
      setDialogPostReaction({
        isOpen: true,
        post: post,
        postReaction,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenReactionDialog]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  // --------------------------- handle scroll fetch more data ----------------

  // const [hasScroll, setHasScroll] = useState<boolean>(false);
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = () => {
    // setHasScroll(true);
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {
      // setHasScroll(false);
    }, 500);
    const container = scrollContainerRef.current;
    if (!container || isFetching) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      fetchMoreData();
    }
  };

  const navigate = useNavigate();
  const handleNavigate = (e: any, id: number) => {
    e.stopPropagation();
    navigate(`${RouteUrl.profile}?id=${id}`);
  };
  const [selectProducts, setSelectProducts] = useState<boolean>(false);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);

  const submitDeleteCampaign = async () => {
    try {
      const url = `${RouteApi.submitDeleteCampaign}token=${token}`;
      const data = {
        campaign_id: selectedProductIds,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setIsDailogDetailCampaings(false);
        setCampaings((prevItemGroups: any) => {
          return {
            ...prevItemGroups,
            data: (prevItemGroups.data || []).filter((item: any) => item.campaign_id !== selectedProductIds),
          };
        });
      } else {
      }
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteCampaign]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [view, setView] = useState("card");
  useEffect(() => {
    const savedView = localStorage.getItem("campaings");
    if (savedView) {
      setView(savedView);
    }
  }, []);
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("campaings", selectedView);
  };

  const allIds = Array.isArray(campaings?.data) ? campaings?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      setSelectedProductIds([]);
    } else {
      // Select all
      setSelectedProductIds(allIds);
    }
  };
  return (
    <>
      <AccountDetailLayout>
        <div
          ref={scrollContainerRef}
          onScroll={handleScroll}
          onWheel={(e) => {
            e.stopPropagation();
          }}
          className="h-[85vh] overflow-y-auto overflow-hidden"
        >
          <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
            <div className="flex justify-between left-0 items-center mb-3 w-full ">
              <div>
                <h1 className="font-semibold lg:text-lg md:text-md text-sm">Campaigns</h1>
                <p className="text-muted-foreground lg:text-md md:text-sm text-[13px]">Boosting Your Brand with Engaging Strategies</p>
              </div>
              <nav className="border-gray-200 pt-5 gap-3 flex items-center justify-between me-5">
                <div className="flex items-center gap-3">
                  <>
                    {!selectProducts ? (
                      <></>
                    ) : (
                      <>
                        {selectedProductIds.length > 0 && (
                          <label
                            onClick={() =>
                              showDialogConfirm({
                                titileButtonSubmit: "Yes, Delete",
                                titileButtonCancel: "No, Cancel",
                                title: "Delete",
                                message: "Do you want to delete?",
                                onSubmit() {
                                  submitDeleteCampaign();
                                },
                              })
                            }
                            className="font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                          >
                            <Trash2 />
                          </label>
                        )}
                      </>
                    )}
                  </>
                  {!selectProducts ? (
                    <label
                      htmlFor=""
                      className="font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                    >
                      <CircleStop
                        onClick={() => {
                          setSelectProducts(true);
                        }}
                        className="text-sm"
                      />
                    </label>
                  ) : (
                    <>
                      <label
                        className={`font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                                        flex items-center justify-center cursor-pointer border 
                                                        ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
                      >
                        <CircleCheck
                          onClick={() => {
                            handleToggleSelectAll();
                          }}
                          className={`${isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"} transition-colors duration-300`}
                        />
                      </label>

                      <label
                        htmlFor=""
                        className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <CircleOff
                          onClick={() => {
                            setSelectedProductIds([]);
                            setSelectProducts(false);
                          }}
                          className="text-sm"
                        />
                      </label>
                    </>
                  )}
                </div>
                {/* Search & View Switch */}
                <div className="flex items-center gap-2 ">
                  {/* View Toggle Button */}
                  <HoverCardDetail
                    title=""
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">Switch between different display modes to view your Campaigns or items.</p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>
                            <strong>Card View:</strong> Displays items as individual cards with detailed info and visuals.
                          </li>
                          <li>
                            <strong>Table View:</strong> Shows items in a compact, sortable table for easy comparison and bulk actions.
                          </li>
                          <li>Use the toggle to choose the view that best fits your task or preference.</li>
                        </ul>
                      </>
                    }
                  >
                    <div className="relative">
                      {view === "card" ? (
                        <button
                          onClick={() => changeView("table")}
                          className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                        >
                          <Grid2x2 className="font-semibold " />
                        </button>
                      ) : (
                        <button
                          onClick={() => changeView("card")}
                          className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                        >
                          <WalletCards className="font-semibold " />
                        </button>
                      )}
                    </div>
                  </HoverCardDetail>
                </div>
              </nav>
            </div>

            <div className={` z-50 w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar `}>
              <div className="relative w-full z-50 ">
                <div className="flex space-x-2 w-full">
                  <div
                    onClick={() => {
                      if (selectCampaingTypes === "All") {
                        setSelectCampaingTypes("");
                      }
                      handleClickCategory({
                        types: "",
                      });
                    }}
                    className={` lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                      selectCampaingTypes === "" ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"
                    } `}
                  >
                    <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                  </div>
                  {/* Product Categories */}
                  <div className="space-x-2 flex">
                    {campaingsloading ? (
                      <ShimmerDepartmentRender />
                    ) : (
                      <>
                        {types?.map((type: any, index: any) => {
                          const statusBgColor =
                            selectCampaingTypes === "In Review"
                              ? "bg-yellow-500 text-white"
                              : selectCampaingTypes === "Draft"
                              ? "bg-gray-200 dark:bg-accent "
                              : selectCampaingTypes === "Approved"
                              ? "bg-blue-500 text-white"
                              : selectCampaingTypes === "Rejected"
                              ? "bg-red-500 text-white"
                              : selectCampaingTypes === "Completed"
                              ? "bg-green-500 text-white"
                              : "";
                          return (
                            <button
                              key={index}
                              onClick={() => {
                                handleClickCategory({
                                  types: type ?? "",
                                });
                              }}
                              className={` focus:border-none outline-none whitespace-nowrap border lg:px-4 md:px-4 px-2 py-0 rounded-lg lg:text-sm md:text-sm text-[12px] font-semibold
                                ${selectCampaingTypes === (type ? type.toString() : "") ? `${statusBgColor}` : "dark:hover:bg-slate-900"}`}
                            >
                              {type}
                            </button>
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {view === "card" ? (
            <div className="pb-3 h-full mt-5">
              <>
                {campaingsloadingSearch ? (
                  <>
                    <div className={`grid grid-cols-1 ${window.innerWidth <= 1500 ? "lg:grid-cols-2" : "lg:grid-cols-3"} md:grid-cols-1 gap-2 `}>
                      {[...Array(3)].map((_, index) => (
                        <Card key={index} className="overflow-hidden p-2  ">
                          <div className="flex lg:flex-row md:flex-row flex-col py-[9px] ps-[9px]">
                            <Skeleton className="lg:w-[230px] md:w-[230px] w-full h-[400px]" />
                            <div className="lg:ps-5 md:ps-5  mt-5">
                              <Skeleton className="w-48 h-6" />
                              <Skeleton className="w-24 h-6 mt-2" />
                              <div className="flex flex-col justify-start w-full gap-2 mt-5">
                                {[...Array(4)].map((_, index) => (
                                  <div key={index} className="flex flex-col justify-start h-[60px]">
                                    <Skeleton className="w-16 h-4" />
                                    <div className="flex justify-start -space-x-4 rtl:space-x-reverse mt-1">
                                      {[...Array(3)].map((_, index) => (
                                        <span key={index} className="w-8 h-8 rounded-full border-2 bg-[#f2f6f9] dark:bg-[#141d2e]" />
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      onWheel={(e) => {
                        e.stopPropagation();
                      }}
                      className={`grid grid-cols-1 md:grid-cols-1    ${window.innerWidth <= 1500 ? "lg:grid-cols-2" : "lg:grid-cols-3"}  gap-3 mb-8`}
                    >
                      {campaings?.data?.map((item: any, index: any) => {
                        const statusBgColorCampaings =
                          item.status === "In Review"
                            ? "bg-yellow-500"
                            : item.status === "Draft"
                            ? "bg-gray-300"
                            : item.status === "Approved"
                            ? "bg-blue-500"
                            : item.status === "Rejected"
                            ? "bg-red-500"
                            : item.status === "Completed"
                            ? "bg-green-500"
                            : "";
                        return (
                          <Card
                            onWheel={(e) => e.stopPropagation()}
                            onClick={() => {
                              if (selectProducts) {
                                setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                return;
                              } else {
                                setIsDailogDetailCampaings(true);
                                getCampaignDetail(item.campaign_id);
                              }
                            }}
                            key={index}
                            className={`${
                              selectedProductIds.includes(item.id) ? "border-2 border-blue-500" : ""
                            } overflow-hidden   p-2  lg:h-[500px] md:h-[500px] flex lg:flex-row md:flex-row flex-col justify-between cursor-pointer`}
                          >
                            <div className="flex aspect-[9/16] cursor-pointer relative  ">
                              <div className={`absolute z-40 top-0 left-0  text-white px-2 py-1 rounded-br-md rounded-tl-md mt-0 ${statusBgColorCampaings} `}>
                                <span className={`text-sm `}>{item?.status}</span>
                              </div>
                              {postContents(item?.post)}
                              <div
                                className={`${
                                  selectedProductIds.includes(item.id) ? "bg-white" : ""
                                } w-4 h-4 z-20 rounded-full flex items-center justify-center absolute right-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                              >
                                {selectedProductIds.includes(item.id) ? (
                                  <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                ) : (
                                  <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                )}
                              </div>
                            </div>
                            <div className="flex flex-1 pl-5  flex-col justify-start relative">
                              <div className="flex flex-col gap-[7px]">
                                <div className="flex justify-between items-center pe-3">
                                  <p className="lg:text-lg md:text-md line-clamp-2 ">{item?.campaign_type}</p>
                                  {selectProducts === true && <div className="flex  absolute  right-2 top-2 w-[60px] h-[30px]"> </div>}

                                  <div onClick={(e) => e.stopPropagation()} onWheel={(e) => e.stopPropagation()}>
                                    <SwitchYesNo
                                      id={`campaign_type_id_${index}`}
                                      value={item?.inactived === "Yes" ? "No" : "Yes"}
                                      onChange={(value) => {
                                        setCampaings((prev: any) => {
                                          const newData = prev.data.map((itm: any, i: number) => {
                                            if (i === index) {
                                              const updated = {
                                                ...itm,
                                                inactived: itm.inactived === "Yes" ? "No" : "Yes", // or use `updateValue`
                                              };
                                              return updated;
                                            }
                                            return { ...itm }; // 👈 return a clone for ALL items
                                          });

                                          return {
                                            ...prev,
                                            data: [...newData], // 👈 create a brand new array
                                          };
                                        });

                                        submitActiveCampaign(item?.campaign_id, value); // Call backend API
                                      }}
                                    />
                                  </div>
                                </div>
                                <p className="lg:text-md md:text-sm line-clamp-2 h-[45px]">{item?.post?.media_title}</p>

                                <p className="lg:text-md md:text-sm line-clamp-2">
                                  {item?.impression_count} {item?.impression_count > 1 ? "Impressions" : "Impression"}
                                </p>
                                <p className="lg:text-md md:text-sm line-clamp-2">
                                  {item?.result_count} {item?.result_count > 1 ? "Results" : "Result"}
                                </p>
                                {!isNaN(Number(item.budget_amount)) && (
                                  <span className="text-lg font-semibold ">
                                    ${Number(item.budget_amount).toFixed(2)}
                                    <span className="lg:text-md font-semibold mt-5"> Budget </span>
                                  </span>
                                )}
                              </div>

                              <div className="flex flex-col justify-start w-full gap-2 mt-3 relative ">
                                {selectProducts === true && <div className="  absolute left-0 top-0 w-full h-full z-50"></div>}

                                <div className=" font-medium text-muted-foreground pt-1 flex flex-col  justify-start h-[60px]">
                                  <span className="text-sm ">
                                    <span
                                      className=" cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onOpenReactionDialog(item?.post, PostReaction.comment);
                                      }}
                                    >
                                      {item?.post?.comment_count} Comment
                                    </span>
                                  </span>
                                  <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                                    {item?.post?.comment_users?.map((item: any, index: any) => {
                                      return (
                                        <div key={index}>
                                          {/* <ImageUrlProfile
                                            isThumbnail={false}
                                            isLinkProfile={true}
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                            user={item?.post}
                                            alt="User avatar"
                                          /> */}
                                          <img
                                            onClick={(e) => {
                                              handleNavigate(e, item.id);
                                            }}
                                            src={item?.picture ? item?.picture : noneProfile}
                                            alt="User avatar"
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                          />
                                        </div>
                                      );
                                    })}
                                    {item?.comment_count > 3 ? (
                                      <p className="flex items-center justify-center w-8 h-8 text-[10px] font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600 dark:border-gray-800">
                                        +{Service.abbreviateNumber(item.comment_count - 3)}
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <div className=" font-medium text-muted-foreground pt-1 flex flex-col justify-start h-[60px]">
                                  <span className="text-sm">
                                    <span
                                      className=" cursor-pointer hover:border-1 border-gray-500"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onOpenReactionDialog(item, PostReaction.share);
                                      }}
                                    >
                                      {item?.post?.reaction_share_count} Shared
                                    </span>
                                  </span>
                                  <div className="flex justify-start -space-x-4 rtl:space-x-reverse ">
                                    {item?.post?.share_users?.map((item: any, index: any) => {
                                      return (
                                        <div key={index}>
                                          <img
                                            onClick={(e) => {
                                              handleNavigate(e, item.id);
                                            }}
                                            src={item?.picture ? item?.picture : noneProfile}
                                            alt="User avatar"
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                                <div className=" font-medium text-muted-foreground pt-1 flex flex-col justify-start h-[60px]">
                                  <span className="text-sm">
                                    <span
                                      className=" cursor-pointer hover:border-1 border-gray-500"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onOpenReactionDialog(item, PostReaction.like);
                                      }}
                                    >
                                      {item?.post?.reaction_like_count} Likes
                                    </span>
                                  </span>
                                  <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                                    {item?.post?.like_users?.map((item: any, index: any) => {
                                      return (
                                        <div key={index}>
                                          {/* <ImageUrlProfile
                                            isLinkProfile={true}
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                            user={item?.post}
                                            alt="User avatar"
                                          /> */}
                                          <img
                                            onClick={(e) => {
                                              handleNavigate(e, item.id);
                                            }}
                                            src={item?.picture ? item?.picture : noneProfile}
                                            alt="User avatar"
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                                <div className=" font-medium text-muted-foreground pt-1 flex flex-col  justify-start h-[60px]">
                                  <span className="text-sm">
                                    <span
                                      className=" cursor-pointer"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onOpenReactionDialog(item, PostReaction.view);
                                      }}
                                    >
                                      {item?.post?.reach_count} Reachs
                                    </span>
                                  </span>
                                  <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                                    {item?.post?.reach_users?.map((item: any, index: any) => {
                                      return (
                                        <div key={index}>
                                          {/* <ImageUrlProfile
                                            isLinkProfile={true}
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                            user={item?.post}
                                            alt="User avatar"
                                          /> */}
                                          <img
                                            onClick={(e) => {
                                              handleNavigate(e, item.id);
                                            }}
                                            src={item?.picture ? item?.picture : noneProfile}
                                            alt="User avatar"
                                            className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                          />
                                        </div>
                                      );
                                    })}
                                    {item?.reach_count > 3 ? (
                                      <p className="flex items-center justify-center w-8 h-8 text-xs font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600 dark:border-gray-800">
                                        +{Service.abbreviateNumber(item.reach_count - 3)}
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card>
                        );
                      })}
                      {laodingScroll && hasMoreData && (
                        <>
                          {[...Array(3)].map((_, index) => (
                            <Card key={index} className="overflow-hidden p-2  ">
                              <div className="flex lg:flex-row md:flex-row flex-col py-[9px] ps-[9px]">
                                <Skeleton className="lg:w-[230px] md:w-[230px] w-full h-[400px]" />
                                <div className="lg:ps-5 md:ps-5  mt-5">
                                  <Skeleton className="w-48 h-6" />
                                  <Skeleton className="w-24 h-6 mt-2" />
                                  <div className="flex flex-col justify-start w-full gap-2 mt-5">
                                    {[...Array(4)].map((_, index) => (
                                      <div key={index} className="flex flex-col justify-start h-[60px]">
                                        <Skeleton className="w-16 h-4" />
                                        <div className="flex justify-start -space-x-4 rtl:space-x-reverse mt-1">
                                          {[...Array(3)].map((_, index) => (
                                            <span key={index} className="w-8 h-8 rounded-full border-2 bg-[#f2f6f9] dark:bg-[#141d2e]" />
                                          ))}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </Card>
                          ))}
                        </>
                      )}
                    </div>
                  </>
                )}
              </>
            </div>
          ) : (
            <>
              {campaingsloadingSearch ? (
                <div className=" mt-5">
                  <SkeletonMusicLibrariesTable />
                </div>
              ) : (
                <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden pb-3 h-full mt-5">
                  <thead className="sticky top-0 left-0 bg-gray-200 dark:bg-[#2c3a52] w-full">
                    <tr className="border-none ">
                      <th className="py-5  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                      <th className=" px-4 text-start whitespace-nowrap w-[100px] ">Campaign type</th>
                      <th className=" px-4 ">Title</th>
                      <th className=" px-4">Impressions</th>
                      <th className=" px-4">Results</th>
                      <th className=" px-4">Budget</th>
                      <th className=" px-4">Comments</th>
                      <th className=" px-4">Shared</th>
                      <th className=" px-4">Likes</th>
                      <th className=" px-4">Reachs</th>
                      <th className=" px-4 first:rounded-tl-md last:rounded-tr-md">Status</th>
                      <th className=" px-4 first:rounded-tl-md last:rounded-tr-md">Action</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {campaings?.data?.map((item: any, index: number) => {
                      const statusBgColorCampaings =
                        item.status === "In Review"
                          ? "bg-yellow-500"
                          : item.status === "Draft"
                          ? "bg-gray-300"
                          : item.status === "Approved"
                          ? "bg-blue-500"
                          : item.status === "Rejected"
                          ? "bg-red-500"
                          : item.status === "Completed"
                          ? "bg-green-500"
                          : "";
                      return (
                        <tr
                          onClick={() => {
                            if (selectProducts) {
                              setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                              return;
                            } else {
                              setIsDailogDetailCampaings(true);
                              getCampaignDetail(item.campaign_id);
                            }
                          }}
                          key={index}
                          className={`text-center cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                        >
                          <td className="relative w-[300px]  ">
                            <div className="flex aspect-[9/16] cursor-pointer relative  ">{postContents(item?.post)}</div>
                            <div
                              className={`${
                                selectedProductIds.includes(item.id) ? "bg-white" : ""
                              } w-4 h-4 z-10 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                            >
                              {selectedProductIds.includes(item.id) ? (
                                <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                              ) : (
                                <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                              )}
                            </div>
                          </td>
                          <td className="py-2 px-4 text-md font-semibold text-start  w-[100px]">{item?.campaign_type}</td>
                          <td className="py-2 px-4 text-md font-semibold w-[400px]  text-center line-clamp-2 pt-[110px]">{item?.post?.media_title}</td>
                          <td className="py-2 px-4 text-md font-semibold"> {item?.impression_count}</td>
                          <td className="py-2 px-4 text-lg">{item?.result_count}</td>
                          <td className="py-2 px-4 text-lg"> ${Number(item.budget_amount).toFixed(2)}</td>
                          <td className="py-2 px-4 text-lg"> {item?.post?.comment_count}</td>
                          <td className="py-2 px-4 text-lg"> {item?.post?.reaction_share_count}</td>
                          <td className="py-2 px-4 text-lg"> {item?.post?.reaction_like_count}</td>
                          <td className="py-2 px-4 text-lg"> {item?.post?.reach_count}</td>
                          <td className="py-2 px-4 text-md  font-semibold w-[100px] ">
                            <div className={`${statusBgColorCampaings}  text-white px-3 py-1 mt-0 rounded-tl-md rounded-br-md`}>
                              <span className="text-sm whitespace-nowrap ">{item?.status}</span>
                            </div>
                          </td>
                          <td className="py-2 px-4 text-md  font-semibold w-[100px] relative ">
                            {selectProducts && <div className=" w-full h-full absolute top-0 left-0"></div>}
                            <div onClick={(e) => e.stopPropagation()} onWheel={(e) => e.stopPropagation()}>
                              <SwitchYesNo
                                id={`campaign_type_id_${index}`}
                                value={item?.inactived === "Yes" ? "No" : "Yes"}
                                onChange={(value) => {
                                  setCampaings((prev: any) => {
                                    const newData = prev.data.map((itm: any, i: number) => {
                                      if (i === index) {
                                        const updated = {
                                          ...itm,
                                          inactived: itm.inactived === "Yes" ? "No" : "Yes", // or use `updateValue`
                                        };
                                        return updated;
                                      }
                                      return { ...itm }; // 👈 return a clone for ALL items
                                    });

                                    return {
                                      ...prev,
                                      data: [...newData], // 👈 create a brand new array
                                    };
                                  });

                                  submitActiveCampaign(item?.campaign_id, value); // Call backend API
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
          <DailogDetailCampaings
            campaingsDetailLoading={campaingsDetailLoading}
            campaingsDetail={campaingsDetail}
            isDailogDetailCampaing={isDailogDetailCampaing}
            setIsDailogDetailCampaings={setIsDailogDetailCampaings}
            onValueChange={({ valuse, id, name }) => {
              if (name === "check_status") {
                setCampaings((prev: any) => {
                  const newData = prev.data.map((itm: any, i: number) => {
                    if (itm.campaign_id === id) {
                      const updated = {
                        ...itm,
                        inactived: itm.inactived === "Yes" ? "No" : "Yes",
                      };
                      return updated;
                    }

                    return { ...itm }; // 👈 return a clone for ALL items
                  });

                  return {
                    ...prev,
                    data: [...newData], // 👈 create a brand new array
                  };
                });
              } else if (name === "delete") {
                setCampaings((prevItemGroups: any) => {
                  return {
                    ...prevItemGroups,
                    data: (prevItemGroups.data || []).filter((item: any) => item.campaign_id !== id),
                  };
                });
              }
            }}
          />
        </div>
      </AccountDetailLayout>
      {dialogPostReaction.isOpen && (
        <DialogPostReaction
          post={dialogPostReaction.post}
          isDialogOpen={dialogPostReaction.isOpen}
          postReaction={dialogPostReaction.postReaction}
          setIsDialogOpen={(isOpen) => setDialogPostReaction({ ...dialogPostReaction, isOpen })}
        />
      )}
    </>
  );
}
